import React, { useState, useEffect } from "react";
import axios from "axios";
import { Row, Col } from "react-bootstrap";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import { DSR } from "../../ReusableComponents/CommonApis";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import { FaRegEdit } from "react-icons/fa";
import { HiMiniPlusSmall } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { SchoolData } from "../../Redux/Reducers/NCLadmin/AddEditSchool";
import { useSelector, useDispatch } from "react-redux";
import Loading from "../../Student/Reusablecomponents/Loading";
import { FaRegEye } from "react-icons/fa";
import { Society } from "../../ReusableComponents/NCLAdminDropdowns";
import { FaClockRotateLeft } from "react-icons/fa6";
import { ViewUserActivityLog } from "../../ReusableComponents/CommonApis";

const Schools = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const TrackDetails = JSON.parse(localStorage.getItem("Schools"));
  const [SelectINID, SetSelectINID] = useState();
  const [Load, SetLoad] = useState(false);
  const [InstId, SetInstId] = useState();
  const [INAddres, SetINAddres] = useState();
  const [SRSData, SetSRSData] = useState(TrackDetails?.Region);
  const [SData, SetSData] = useState(TrackDetails?.State);
  const [DistData, SetDistData] = useState(TrackDetails?.District);
  const [SocietyId, SetSocietyId] = useState(TrackDetails?.Society);
  const [SchoolValues, setSchoolValues] = useState([]);
  const [visiblePasswords, setVisiblePasswords] = useState({});
  const [DisplaySchoolStatus, SetDisplaySchoolStatus] = useState("Active");
  const [LogData, SetLogData] = useState();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const GetInstitutes = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(process.env.REACT_APP_API_BASE_URL + `/NCLAdmin/Institutes`, {
        headers: { XApiKey: process.env.REACT_APP_XApiKey },
      })
      .then((res) => {
        const Institutes = Array.from(
          res.data
            .reduce(
              (map, item) =>
                map.set(item.instituteName, {
                  display: item.instituteName,
                  value: item.instituteId,
                }),
              new Map()
            )
            .values()
        );
        SetSelectINID(TrackDetails?.INST || Institutes[0].value);
        SetInstId(Institutes);
        SetINAddres(res.data);
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    GetInstitutes();
  }, []);

  const HandleInstituteChange = (e) => {
    SetSelectINID(e);
    SetSRSData("");
    SetSData();
    SetDistData();
    SetSocietyId();
  };

  const HandleAddSchool = () => {
    const Tracking = {
      INST: SelectINID,
      Region: SRSData,
      State: SData,
      District: DistData,
      Society: SocietyId,
    };
    localStorage.setItem("Schools", JSON.stringify(Tracking));
    navigate("/NCLAdmin/Schools/AddSchool");
    dispatch(SchoolData({ AddEditSchoolDetails: "" }));
  };

  const handleEdit = (SingleSchool) => {
    const Tracking = {
      INST: SelectINID,
      Region: SRSData,
      State: SData,
      District: DistData,
      Society: SocietyId,
    };
    localStorage.setItem("Schools", JSON.stringify(Tracking));
    const [Region, State, District] = (() => {
      const parts = SingleSchool.hierarchyKey.split(",");
      return parts.length > 2 ? parts : [undefined, ...parts];
    })();
    const updatedData = { ...SingleSchool, Region, State, District };
    dispatch(SchoolData({ AddEditSchoolDetails: updatedData }));
    navigate("/NCLAdmin/Schools/AddSchool");
  };

  //To get schools
  const GetSchools = async () => {
    SetLoad((prev) => !prev);
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
        `/NCLAdmin/GetSchools?InstituteId=${SelectINID}&Hvalue=${HIID()}&SocietyId=${SocietyId?.value || 0}&IsActive=${DisplaySchoolStatus === "Active" ? 1 : 0}`,
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
        }
      );
      setSchoolValues(response.data);
      SetLoad((prev) => !prev);
    } catch (error) {
      console.error("Error fetching School data:", error);
      return [];
    }
  };
  useEffect(() => {
    if (SelectINID && SData && DistData) {
      GetSchools();
    }
  }, [SelectINID, SRSData, SData, DistData, SocietyId, DisplaySchoolStatus]);

  const HIID = () => {
    if (SelectINID === "1" || SelectINID === "3" || SelectINID === "6") {
      return [SRSData, SData, DistData];
    } else {
      return [SData, DistData];
    }
  };
  const NavigateSchools = (Row) => {
   const Tracking = {
      INST: SelectINID,
      Region: SRSData,
      State: SData,
      District: DistData,
      Society: SocietyId,
    };
    localStorage.setItem("Schools", JSON.stringify(Tracking));
    navigate("/NCLAdmin/Schools/StudentDetails",{ state: { UserID: Row?.userId, SchoolID:Row?.schoolID,SchoolName: Row?.schoolName } });
  }
  const Columns = [
    { name: "School Name", selector: "schoolName", sortable: true, 
      cell: (row) => (<div className="LinkStyles" title="Click here to view Student registrations" onClick={() => NavigateSchools(row)}>{row.schoolName}</div>) },
    { name: "School U-DISC Code", selector: "udiseCode", sortable: false },
    { name: "Email Id", selector: "eMail", sortable: true },
    { name: "Contact Name", selector: "contactName", sortable: true },
    { name: "Contact Number", selector: "contactPhone", sortable: true },
    { name: "LoginId", selector: "loginId", sortable: true },
    {
      name: "Password",
      cell: (row) => (
        <div className="dflex h-100 gap-1" style={{ justifyContent: "center" }}>
          {visiblePasswords[row.password] ? (
            <span>{row.password}</span>
          ) : (
            <span style={{ fontsize: "10px" }}>*****</span>
          )}
          <FaRegEye
            className="CPointer"
            title={
              visiblePasswords[row.password] ? "Hide Password" : "Show Password"
            }
            onClick={() =>
              setVisiblePasswords((prev) => ({
                ...prev,
                [row.password]: !prev[row.password],
              }))
            }
          />
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div
          className="dflex"
          style={{ gap: "15px", justifyContent: "center" }}
        >
          <FaRegEdit
            title="Edit School Details"
            className="CPointer"
            style={{ color: "#624DE3" }}
            size={18}
            onClick={() => handleEdit(row)}
          />
        </div>
      ),
    },
  ];



  return (
    <>
      <div className="TeacherBgImage">
        <div className="MainHeading" style={{ marginTop: "10px" }}>
          Schools
        </div>
        <div className="container-fluid mt-2 InputFIlters">
          <label>Input</label>
          <br />
          <Row>
            <Col>
              {InstId && (
                <DropdownValues
                  className="NCLDropdown w-100"
                  options={InstId}
                  selectoption={SelectINID}
                  onChange={(e) => {
                    HandleInstituteChange(e.target.value);
                  }}
                  labelname={<div className="DropdownHeader">Institute :</div>}
                />
              )}
            </Col>

            {(SelectINID === "8" || SelectINID === "9" || SelectINID === "5") && (
              <Col>
                <Society
                  className="NCLDropdown w-100"
                  PId={SelectINID}
                  id="0"
                  SOption={SocietyId}
                  StoreValue={SetSocietyId}
                  onChange={(e) => {
                    SetSocietyId(e);
                  }}
                  labelname={<div className="DropdownHeader">Society :</div>}
                />
              </Col>
            )}
            {(SelectINID === "1" || SelectINID === "3" || SelectINID === "6") && (
              <Col>
                {" "}
                <DSR
                  className="NCLDropdown w-100"
                  PId={SelectINID}
                  SID="0"
                  StoreValue={SetSRSData}
                  SOption={SRSData}
                  RID="0"
                  onChange={(e) => {
                    SetSRSData(e);
                  }}
                  labelname={<div className="DropdownHeader">Region :</div>}
                />
              </Col>
            )}

            <Col>
              <DSR
                className="NCLDropdown w-100"
                PId={SelectINID}
                SID="0"
                StoreValue={SetSData}
                SOption={SData}
                RID={SRSData || 0}
                INALL={true}
                onChange={(e) => {
                  SetSData(e);
                }}
                labelname={<div className="DropdownHeader">State :</div>}
              />
            </Col>

            <Col>
              {" "}
              <DSR
                className="NCLDropdown w-100"
                PId={SelectINID}
                SID={SData || 0}
                StoreValue={SetDistData}
                SOption={DistData}
                RID={SRSData || 0}
                INALL={true}
                onChange={(e) => {
                  SetDistData(e);
                }}
                labelname={<div className="DropdownHeader">District :</div>}
              />
            </Col>
          </Row>
        </div>
        <div className="dflex JSBetween alignitems mt-2" >
          <div>
            <b
              className="dflex alignitems JCCenter gap-1"
              style={{
                whiteSpace: "nowrap",
                color: "#4450D3",
                cursor: "pointer",
              }}
              onClick={() => SetLogData(true)}
            >
              <FaClockRotateLeft fontSize={20} /> View Activity Log
            </b></div>
          <div className="dflex alignitems gap-3">
            <div className="dflex gap-3">
              <span>
                {" "}
                <input
                  type="radio"
                  name="ActiveStatus"
                  value="Active"
                  defaultChecked={DisplaySchoolStatus === "Active"}
                  onChange={(e) => {
                    SetDisplaySchoolStatus(e.target.value);
                    setSchoolValues([]);
                  }}
                />{" "}
                Active{" "}
              </span>
              <span style={{ color: "#878997" }}>
                {" "}
                <input
                  type="radio"
                  name="ActiveStatus"
                  value="Inactive"
                  defaultChecked={DisplaySchoolStatus === "Inactive"}
                  onChange={(e) => {
                    SetDisplaySchoolStatus(e.target.value);
                    setSchoolValues([]);
                  }}
                />{" "}
                Inactive{" "}
              </span>
            </div>
            <button className="Buttons AddButton dflex alignitems JCCenter gap-1" onClick={HandleAddSchool}>
              <HiMiniPlusSmall />
              Add School{" "}
            </button>
          </div>
        </div>

        {LogData && (
          <ViewUserActivityLog
            UserId={items?.userId}
            UTId={2}
            Close={() => SetLogData(false)}
          />
        )}

        <DataTable
          data={SchoolValues}
          columns={Columns}
          className="NCLDataTable Card mt-2"
          style={{ marginTop: "40px" }}
          Dropdownvalues={["10", "25", "50", "100"]}
          ShowPagination={true}
          ShowPagecount={true}
        />
      </div>
      {Load && <Loading />}
    </>
  );
};
export default Schools;
